const Sandbox = () => <p>sandbox</p>

export default Sandbox
